<template>
  <div class="page-content">
    <!-- 搜索区域 -->
    <div class="searchContent">
      产品：
    <el-select  size="small" v-model="search.productKey" filterable placeholder="请选择" @change="changeProduct">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <div class="searchInputContent">
      <div class="input">
        <el-row :span="24">
          <el-col :span="5"><el-input v-model="search.deviceName" size="small" placeholder="请输入 DeviceName"></el-input></el-col>
          <el-col :span="5"  v-show="activeName === '1'">
            <el-input
              v-model="search.traceId"
              size="small"
              placeholder="请输入 TraceId">
            </el-input>
          </el-col>
          <!-- <el-col :span="7"><el-input v-model="search.messageId" size="small" placeholder="请输入内容关键字、MessageId"></el-input></el-col> -->
          <el-col :span="2">
            <el-select  size="small" v-model="search.period" filterable placeholder="请选择" @change="changePeriod">
                <el-option
                  v-for="item in periodList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-col>
          <el-col :span="10">
            <el-date-picker
            size="small"
              v-if="search.showTime"
              v-model="search.timeArr"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
        </el-row>
      </div>
      <div class="btn">
        <el-row>
          <el-col>
            <el-button type="primary" size="small" class="" icon="el-icon-search" @click="inputSearch">搜索</el-button>
            <el-button type="" size="small" icon="el-icon-delete" @click="inputReset">重置</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    </div>
    <el-tabs type="card" class="tab" v-model="activeName"  @tab-click="handleClick">
      <el-tab-pane label="消息记录" name="1">
         <keep-alive>
          <mesRecord v-if="activeName==='1'"
          :productKey="search.productKey"></mesRecord>
         </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="上下线记录" name="2">
         <keep-alive>
          <onlineRecord
          v-if="activeName==='2'"
          :productKey="search.productKey">
          </onlineRecord>
         </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { productOptionsList } from '@/api/productRegistration'
import mesRecord from '@/components/systemOperation/mesRecord'
import onlineRecord from '@/components/systemOperation/onlineRecord'
import { eventBus } from '@/utils/eventBus'
export default {
  components: {
    mesRecord,
    onlineRecord
  },
  data () {
    return {
      options: [],
      activeName: '1',
      search: {
        deviceName: '',
        traceId: '',
        // messageId: '',
        timeArr: '',
        showTime: false,
        productKey: '',
        period: ''
      },
      total: 0,
      periodList: [
        { label: '15分钟', value: '1' },
        { label: '1 小时', value: '2' },
        { label: '4 小时', value: '3' },
        { label: '24 小时', value: '4' },
        { label: '7天', value: '5' },
        { label: '自定义', value: '6' }
      ],
      productKey: ''
    }
  },
  methods: {
    getOptionsProductList () {
      productOptionsList()
        .then(res => {
          res = res.data
          this.options = res.data.map(item => {
            return {
              value: item.productKey,
              label: item.productName
            }
          })
          // this.productList = res.data.data
          console.log('this.productList:', this.productList)
        })
    },
    changeProduct (key) {
      // console.log('选择产品的key：', key)

    },
    changePeriod (key) {
      console.log('period:', key)
      key === '6'
        ? this.search.showTime = true
        : this.search.showTime = false
    },
    handleClick (tab) {
      console.log('tab切换：', tab.index)
    },
    inputSearch () {
      // console.log('this.search:', this.search)
      // this.searchProvide = {
      //   pageNumber: 1,
      //   pageSize: 10
      // }
      if (this.activeName === '1') {
        console.log('进入')
        const params = {
          pageNumber: 1,
          pageSize: 10,
          deviceName: this.search.deviceName,
          traceId: this.search.traceId,
          beginTime: this.search.timeArr[0],
          endTime: this.search.timeArr[1]
        }
        eventBus.$emit('search-mes-log', params)
      } else {
        const params = {
          pageNumber: 1,
          pageSize: 10,
          deviceName: this.search.deviceName,
          beginTime: this.search.timeArr[0],
          endTime: this.search.timeArr[1]
        }
        eventBus.$emit('search-online-log', params)
      }
    },
    inputReset () {
      this.search = Object.assign(this.search, {
        deviceName: '',
        traceId: '',
        // messageId: '',
        timeArr: '',
        showTime: false,
        productKey: '',
        period: ''
      })
    }
  },
  created () {
    this.getOptionsProductList()
  }
}
</script>
<style lang="less" scope>
.page-content{
  .searchContent{
    padding-bottom: 10px;
    .tab{
      margin-top: 20px;
    }
    .el-col{
      margin-top: 10px;
      margin-left: 10px;
    }
    .searchInputContent{
      display: flex;
      .input{
        flex: auto;
      }
      .searchBtn{
        margin-top: 10px;
      }
    }
  }

}
</style>
